<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import WatermarkUtil from '@/utils/watermark'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapGetters([
      'token',
      'user'
    ])
  },
  watch: {
    user: {
      handler(newUser) {
        if (newUser && newUser.dealerId) {
          this.initWatermark()
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.initWatermark()
  },
  beforeDestroy() {
    WatermarkUtil.destroyWatermark()
  },
  methods: {
    async initWatermark() {
      if (this.token && this.user) {
        await WatermarkUtil.initWatermark()
      }
    }
  }
}
</script>
